import styled from 'styled-components'

import { hexRgba } from '../../../utils/style-fns'
import { grayDark } from '../../../utils/style-utils'

interface Props {
  size?: number
}

const GameWrapper = styled.div<Props>`
  position: relative;
  background-color: ${hexRgba(grayDark, 0.5)};
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  ${(props) =>
    props.size
      ? `grid-column: span ${props.size};
     grid-row: span ${props.size};`
      : ''}
`

export default GameWrapper
